export default "__VITE_PUBLIC_ASSET__ebdf10a3__"